import React, { useEffect } from 'react';
import './Details.css';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Charts from '../Charts';
import Logs from '../Logs/Logs';
import Alerts from '../Alerts/Alerts';
import ServiceDetails from '../Insidedetails/Servicedetails';
import Hamburger from '../../components/HamburgerMenu/HamburgerMenu';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { onUpdateService } from '../../store/app/actions';
import CircularProgress from '@mui/material/CircularProgress';

export function Details({ sprogress, onUpdateService }) {
  const params = useParams();
  const [value, setValue] = React.useState(0);
  const handleTabs = (event, val) => {
    setValue(val);
  };

  const tabStyle = {
    '& .Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiTab-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiTabs-root': {
      paddingLeft: '15px',
    },
  };
  useEffect(() => {
    onUpdateService(params.id);
  }, [sprogress]);
  const [, setDropdown] = React.useState(false);
  useEffect(() => {
    return () => {
      onUpdateService('');
    };
  }, []);
  const handleChange = (event) => {
    setDropdown(true);
  };
  return (
    <div className="totals">
      {!sprogress && <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%' }} />}
      {sprogress && (
        <div>
          <h1> Service Monitor </h1>
          <Hamburger></Hamburger>

          <div className="tabs">
            <Tabs sx={tabStyle} value={value} onChange={handleTabs}>
              <Tab label="Monitoring" />
              <Tab label="Logs" onClick={handleChange} />
              <Tab label="Details" />
              <Tab label="Alerts" />
            </Tabs>
          </div>
          {value === 0 && <Charts />}
          {value === 1 && <Logs logtype={'service'} />}
          {value === 2 && <ServiceDetails />}
          {value === 3 && <Alerts logtype={'service'} />}
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    sprogress: state.app.sprogress,
  };
};
const mapDispatchToProps = {
  onUpdateService,
};
export default connect(mapStateToProps, mapDispatchToProps)(Details);
